import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '../shared/services/auth.service';
import { BaseService } from '../shared/services/base.service';
import { UserService } from '../user/services/user.service';
import { Router } from '@angular/router';
import { RolePermission } from '../shared/models/role.permission.enum';


@Component({
  selector: 'app-menu-bar',
  templateUrl: './menu-bar.component.html',
  styleUrls: ['./menu-bar.component.scss']
})
export class MenuBarComponent implements OnInit {
  isExpanded = false;

  private usernameSubscription: Subscription;

  username: string;
  isIDIAdmin: boolean;
  isDealerAdmin: boolean;
  isFieldTech: boolean;

  hideQuoteTabs: boolean;
  quoteOnly: boolean;

  constructor(private userService: UserService, private router: Router) { }

  ngOnInit() {
    this.usernameSubscription = AuthService.authNavStatus$.subscribe(authenticated => {
      this.username = "";
      if (authenticated) {
        let user = AuthService._authUserSource.value;

        this.username = user.firstName;
        this.quoteOnly = user.isQuoteOnly;

        this.isIDIAdmin = authenticated == 'IDI';
        this.isDealerAdmin = BaseService.hasPermission(RolePermission.Admin) && authenticated == 'Dealer';
        this.isFieldTech = BaseService.hasPermission(RolePermission.FieldTechnician);

        this.hideQuoteTabs = this.isFieldTech || this.isIDIAdmin;
      }
    });
  }

  ngOnDestroy() {
    this.usernameSubscription.unsubscribe();
  }

  get hideJobTools(): boolean {
    return this.isIDIAdmin || this.quoteOnly;
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  logout(event: any) {
    event.preventDefault();

    BaseService.logout(this.router);
  }

}
